import { render, staticRenderFns } from "./SeguroModal.vue?vue&type=template&id=f79dc14e"
import script from "./SeguroModal.vue?vue&type=script&lang=js"
export * from "./SeguroModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports